import {
  ApiGenerateInteraction,
  ApiNewProjectRequest,
  ApiOnboardingType,
  ApiSimpleOnboarding,
} from "@incendium/api";
import { onboardingService } from "Apis";

export const listOnboading = async () => {
  const res = await onboardingService.onboardingServiceListOnboarding();
  return res.results || [];
};

export const createOnboarding = async (
  projectId: number,
  onboardingType: ApiOnboardingType,
) => {
  const res = await onboardingService.onboardingServiceCreateOnboarding({
    projectId,
    onboardingType: onboardingType as any,
  });
  return res;
};

export const deleteOnboarding = async (projectId: number) => {
  const res = await onboardingService.onboardingServiceDeleteOnboarding({
    projectId,
  });
  return res;
};

export const updateOnboarding = async (
  projectId: number,
  onBoard: ApiSimpleOnboarding,
) => {
  const res = await onboardingService.onboardingServiceUpdateOnboarding({
    projectId,
    payload: onBoard,
  });
  return res;
};

export const publishOnboarding = async (projectId: number) => {
  const res = await onboardingService.onboardingServicePublishOnboarding({
    projectId,
  });
  return res;
};

export const getOnboading = async (projectId: number) => {
  const res = await onboardingService.onboardingServiceReadOnboarding({
    projectId,
  });
  return res;
};

export const generateInteractions = async (
  projectId: number,
  interactions: ApiGenerateInteraction[],
) => {
  const res = await onboardingService.onboardingServiceGenerateInteractions({
    projectId,
    payload: {
      interactions,
    },
  });
  return res;
};

export const newProject = async (request: ApiNewProjectRequest) => {
  await onboardingService.onboardingServiceNewProject({
    body: request,
  });
};
